import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import buildLuxLoyaltySelectedUpgradeKey from 'luxLoyalty/lib/benefits/buildLuxLoyaltySelectedUpgradeKey'

function getSelectedLuxLoyaltyTargetUpgradePackage(
  selectedPackageOption: OfferPackageOptionView,
  availablePackageOptions: Array<OfferPackageOptionView>,
  luxLoyaltyTargetRoomUpgradesSelected: App.LuxLoyaltyTargetRoomUpgradesSelected | undefined,
): OfferPackageOptionView | undefined {
  const targetUpgradeLePackageUniqueKey = selectedPackageOption.package.luxLoyalty.targetUpgradePackageUniqueKey
  if (!targetUpgradeLePackageUniqueKey) return
  const targetUpgradePackage = availablePackageOptions.find(option => option.package.uniqueKey === targetUpgradeLePackageUniqueKey)

  if (
    !targetUpgradePackage ||
    !targetUpgradePackage?.capacityValid ||
    !targetUpgradePackage?.hotelAvailable
  ) return

  const selectedUpgradeKey = buildLuxLoyaltySelectedUpgradeKey(
    selectedPackageOption.package,
    targetUpgradePackage.package,
  )

  const hasSelectedPackageTargetUpgrade = selectedUpgradeKey ? !!luxLoyaltyTargetRoomUpgradesSelected?.[selectedUpgradeKey] : false

  if (!hasSelectedPackageTargetUpgrade) return

  return targetUpgradePackage
}

export default getSelectedLuxLoyaltyTargetUpgradePackage
